import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import ErrorComponent from '@/components/error';
import { useEntityContext } from '@/entity/hooks/use-entity-context';
import Loading from '../onboardings-shared/components/loading';
import { ONBOARDINGS_ID } from '../onboardings-shared/constants';
import useSelectedOnboarding from '../onboardings-shared/hooks/use-selected-onboarding';
import Section from '../section';
import DeviceInsightsSection from './components/device-insights-section';
import DuplicatesSection from './components/duplicates-section';
import OnboardingList from './components/onboarding-list';
import OnboardingPanel from './components/onboarding-panel';
import OtherInsightsSection from './components/other-insights-section';

/** The onboardings layout from before the strip of tabs, for users who turn the onboardings_strip preview off. */
const ClassicOnboardings = () => {
  const $ = _c(35);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "onboardings"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  const {
    kind
  } = useEntityContext();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      hasCurrentTab: false
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isPending,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    onboardings,
    selectedOnboarding,
    isPagingToTarget,
    setOnboardingId
  } = useSelectedOnboarding(t1);
  let t2;
  if ($[2] !== t) {
    t2 = t(_temp);
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isPending) {
    t3 = isPending && <Loading />;
    $[4] = isPending;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== error) {
    t4 = error && <ErrorComponent error={error} />;
    $[6] = error;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== error || $[9] !== isPending || $[10] !== kind || $[11] !== selectedOnboarding || $[12] !== t) {
    t5 = !isPending && !error && !selectedOnboarding && <p className="text-body-2 text-primary">{t(_temp2, {
        kind
      })}</p>;
    $[8] = error;
    $[9] = isPending;
    $[10] = kind;
    $[11] = selectedOnboarding;
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== fetchNextPage || $[15] !== hasNextPage || $[16] !== isFetchingNextPage || $[17] !== isPagingToTarget || $[18] !== onboardings || $[19] !== selectedOnboarding || $[20] !== setOnboardingId) {
    t6 = selectedOnboarding && <div className="flex flex-col gap-2 p-2 rounded bg-secondary md:flex-row md:items-start md:h-[566px]"><OnboardingList onboardings={onboardings} selectedId={selectedOnboarding.id} onSelect={setOnboardingId} onLoadMore={fetchNextPage} hasMore={hasNextPage} isLoadingMore={isFetchingNextPage} />{isPagingToTarget ? <Loading /> : <OnboardingPanel key={selectedOnboarding.id} onboarding={selectedOnboarding} />}</div>;
    $[14] = fetchNextPage;
    $[15] = hasNextPage;
    $[16] = isFetchingNextPage;
    $[17] = isPagingToTarget;
    $[18] = onboardings;
    $[19] = selectedOnboarding;
    $[20] = setOnboardingId;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== t5 || $[26] !== t6) {
    t7 = <Section title={t2} id={ONBOARDINGS_ID}>{t3}{t4}{t5}{t6}</Section>;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== kind) {
    t8 = kind === "person" && <DuplicatesSection />;
    $[28] = kind;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t10;
  let t9;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <DeviceInsightsSection />;
    t10 = <OtherInsightsSection />;
    $[30] = t10;
    $[31] = t9;
  } else {
    t10 = $[30];
    t9 = $[31];
  }
  let t11;
  if ($[32] !== t7 || $[33] !== t8) {
    t11 = <div className="@container flex flex-col gap-10">{t7}{t8}{t9}{t10}</div>;
    $[32] = t7;
    $[33] = t8;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  return t11;
};
export default ClassicOnboardings;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.noOnboardings;
}